import React, { useEffect, useState } from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import { Card, CardBody } from "../../../../../components/card/card";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

export const options = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    title: {
      display: false,
      text: "Annualize LCC",
    },
  },
  scales: {
    x: {
      color: "#d7d7d7",
      ticks: {
        precision: 0,
        color: "#d5d5d5",
      },
      title: {
        display: true,
        color: "#d7d7d7",
        text: "Year",
      },
      stacked: true,
    },
    y: {
      color: "#d7d7d7",
      ticks: {
        precision: 0,
        color: "#d5d5d5",
      },
      title: {
        display: true,
        color: "#d7d7d7",
        text: "Amount (USD)",
      },
      stacked: true,
    },
  },
};

function App({ changedValue, allData }) {
  const labels = [
    "2015",
    "2016",
    "2017",
    "2018",
    "2019",
    "2020",
    "2021",
    "2022",
    "2023",
    "2024",
    "2025",
    "2026",
    "2027",
    "2028",
    "2029",
    "2030",
    "2031",
    "2032",
  ];
  //generate random data for 7 years with custom min and max
  const generateRandomArray = (length, min, max) => {
    return Array.from(
      { length },
      () => Math.floor(Math.random() * (max - min + 1)) + min
    );
  };
  const array = [
    100000, 80000, 70000, 65000, 60000, 40000, 35000, 30000, 29000, 28000,
    27000, 25000, 24000, 22000, 20000, 19000, 18000,
  ];

  const [data, setData] = useState({
    labels,
    datasets: [
      {
        label: "Annualized LCC",
        data: array,
        backgroundColor: "rgb(255, 99, 132)",
        stack: "stack0",
      },
    ],
  });

  useEffect(() => {
    const data_annualized = allData.map((item) => item["Annualized LCC"]);
    const year = allData.map((item) => item.Year);
    setData({
      labels: year,
      datasets: [
        {
          label: "Annualized LCC",
          data: data_annualized,
          backgroundColor: "rgb(255, 99, 132)",
          stack: "stack0",
        },
      ],
    });
  }, [allData]);

  return (
    <Card className="bg-blue-900 border-theme  mb-3">
      <CardBody>
        <h4>Annualize LCC</h4>
        <div style={{ position: "relative", height: "434px", width: "100%" }}>
          <Bar options={options} data={data} />
        </div>
      </CardBody>
    </Card>
  );
}

export default App;
